import { asId } from '../messages/travelChatModel';

const ENSURE_ALLOWED = new Set(['READY', 'TRAVELING', 'COMPLETED']);
const TERMINAL = new Set(['CANCELLED', 'ARCHIVED']);

export function normalizeJourneyConversation(row) {
  if (!row) return null;
  const conversationId = asId(row.conversationId ?? row.id);
  if (!conversationId) return null;
  return {
    bindingId: asId(row.bindingId),
    journeyId: asId(row.journeyId),
    conversationId,
    conversationType: row.conversationType || 'BUSINESS_GROUP',
    status: row.status || '',
    replay: Boolean(row.replay),
  };
}

export function canEnsureJourneyChat(lifecycleStatus) {
  return ENSURE_ALLOWED.has(String(lifecycleStatus || ''));
}

export function isTerminalJourneyChatLifecycle(lifecycleStatus) {
  return TERMINAL.has(String(lifecycleStatus || ''));
}

export function isConversationNotWritable(conversation) {
  const status = String(conversation?.status || '').toUpperCase();
  return status === 'READONLY' || status === 'CLOSED';
}

export function terminalJourneyChatCopy(lifecycleStatus) {
  if (String(lifecycleStatus || '') === 'CANCELLED') {
    return '這趟旅程已取消，聊天室已設為唯讀。';
  }
  if (String(lifecycleStatus || '') === 'ARCHIVED') {
    return '這趟旅程已封存，聊天室已設為唯讀。';
  }
  return '聊天室目前為唯讀。';
}

export function isJourneyConversationAbsent(cause) {
  const code = cause?.code ?? cause?.raw?.code;
  const key = String(cause?.raw?.key || '');
  return code === 94002 || key === 'travel.journey.conversation.not.found';
}

export function journeyChatGateCopy(lifecycleStatus, hasBinding) {
  if (hasBinding) return null;
  if (canEnsureJourneyChat(lifecycleStatus)) {
    return {
      action: 'ensure',
      title: '尚未開啟旅程聊天室',
      body: '開啟後會使用這趟旅程的共用對話，訊息仍走即時通訊。',
      button: '開啟旅程聊天室',
    };
  }
  if (String(lifecycleStatus || '') === 'DRAFT') {
    return {
      action: 'blocked',
      title: '草稿尚不能開啟聊天室',
      body: '請先把旅程設為可出發後再開啟。',
    };
  }
  if (isTerminalJourneyChatLifecycle(lifecycleStatus)) {
    return {
      action: 'blocked',
      title: '無法新建旅程聊天室',
      body: '此旅程已結束或封存，不能再開新的聊天室。既有對話權限以即時通訊為準。',
    };
  }
  return {
    action: 'blocked',
    title: '目前無法開啟旅程聊天室',
    body: '此旅程狀態不允許建立聊天室。',
  };
}

export function participantContextLine(summaries, memberIds) {
  const names = (memberIds || [])
    .map((id) => summaries?.[id]?.displayName || summaries?.[id]?.username)
    .filter(Boolean);
  if (!names.length) return '';
  return names.join('、');
}
